import React from 'react';

const NicknameIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='currentColor'
    width='24'
    height='24'
    aria-hidden='true'
    className={`eds-icon${className ? ` ${className}` : ''}`}
    {...props}
  >
    {/* Badge body */}
    <rect
      x='2'
      y='5'
      width='20'
      height='16'
      rx='2'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
    />
    {/* Lanyard clip at top */}
    <rect
      x='9'
      y='2'
      width='6'
      height='5'
      rx='1.5'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
    />
    {/* Person head */}
    <circle cx='12' cy='13' r='2' />
    {/* Shoulder arc suggesting a person silhouette */}
    <path
      d='M8 18.5c0-2.2 1.8-4 4-4s4 1.8 4 4'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);

export default NicknameIcon;
